import NeighborhoodPage from "@/components/NeighborhoodPage";

const Gavea = () => (
  <NeighborhoodPage
    name="Gávea"
    slug="gavea"
    description="Um dos endereços mais nobres do Rio, com casas, coberturas e apartamentos rodeados por Mata Atlântica, próximo à PUC, ao Jockey e à Lagoa Rodrigo de Freitas."
  />
);

export default Gavea;
